import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogComponent} from '../dialog/dialog.component';
import {
  EcaseHttpService,
  ECaseNumberFormatterPipe,
  ECaseSnackBarService,
  ECaseUtils,
  PendingChangesGuard,
  RefreshDataService
} from 'synto-common';
import {TranslateService} from '@ngx-translate/core';
import cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'fb-budget-t1',
  templateUrl: './fb-budget-t1.component.html',
  styleUrls: ['./fb-budget-t1.component.scss']
})
export class FbBudgetT1Component implements OnInit, OnDestroy {

  @Input() url: any;
  @Input() selectedLanguage;
  @Input() bphChange: any;
  @Input() confChange: any;
  @Input() isValidHtml: boolean;
  @Input() isValidTable: boolean;
  @Input() globalConf: any;
  @Input() globalPrj: any;
  @Input() selectedSectionId;
  @Input() formId;
  @Input() blockIndex: number;
  @Output() emitOutputEvent = new EventEmitter<any>();
  @Output() emitSaveEvent = new EventEmitter<any>();
  @Output() emitOutputEventForBudgetTableAddRow = new EventEmitter<any>();


  groupedByTableOneRows: Map<any, any> = new Map();
  groupedByTableTwoRows: Map<any, any> = new Map();
  hasOptionSelected: boolean;
  isShowTableRow: boolean;
  tables: any[] = [];
  showEditManpowerTable: boolean;
  showSecondTable: boolean;
  manPowerEditRow;
  manPowerEditRowIndex;
  selectedTableToEdit;
  searchResultForCategory: any = {};
  searchResultForSubCategory;
  manPowerTable = [];
  tempObjectForNotManpowerTable: any = {};
  indexOfEditedTable;
  oldBPHChange;
  subCategoryList = [];
  showSummaryTable: boolean;
  hasAnyNonManpowerRows: boolean ;
  firstNonManpowerIndex ;

  constructor(public dialog: MatDialog,
              private translate: TranslateService,
              private http: EcaseHttpService,
              private eCaseSnackBarService: ECaseSnackBarService,
              private eCaseNumberFormatterPipe: ECaseNumberFormatterPipe,
              private pendingChangesGuard: PendingChangesGuard,
              private refreshDataService: RefreshDataService,
              private translateService: TranslateService) {

  }

  /**
   * @deprecated KFASSYNTO-484 - Separate in budget Summary table Opex from Capex
   */
  getMapValue_(category) {
    if (this.groupedByTableOneRows) {
      this.groupedByTableOneRows = ECaseUtils.groupBy(this.bphChange.numberOfBudgetTables[1].rows, item => item.category.value);
    }
    return this.groupedByTableOneRows.get(category.value);
  }
  getMapValue(category, tableIndex) {
    let groupedRows;
    switch (tableIndex) {
      case 1:
        groupedRows = this.groupedByTableOneRows;
        if (!groupedRows) {
          groupedRows = ECaseUtils.groupBy(this.bphChange.numberOfBudgetTables[1].rows, item => item.category.value);
          this.groupedByTableOneRows = groupedRows;
        }
        break;
      case 2:
        groupedRows = this.groupedByTableTwoRows;
        if (!groupedRows) {
          groupedRows = ECaseUtils.groupBy(this.bphChange.numberOfBudgetTables[2].rows, item => item.category.value);
          this.groupedByTableTwoRows = groupedRows;
        }
        break;
      default:
        throw new Error('Invalid table index');
    }
    return groupedRows.get(category.value);
  }

  getTextLength2(l): number {


    try {
      l = l.toString();
      if (l.length > 9) {
        l = l.slice(0, 9);
      }
      return l.length;
    } catch (e) {
      return 0;
    }
  }

  getTextLength(l): number {
    // try {
    //   l = l.toString();
    //   return l.length;
    // } catch (e) {
    //   return 0;
    // }
    try {
      if (l.toString().length <= this.confChange.maxlength) {
        return l ? l.toString().length : 0;
      } else {
        return this.confChange.maxlength;
      }
    } catch (e) {
      return 0;
    }
  }

  getWordCount(str): number {
    try {
      return (str === '' ? 0 : str.split(' ').filter(item => item !== '').length);
    } catch (e) {
      return 0;
    }
  }

  changeValueEvent(tempObject, key) {
    console.log(this.confChange);
    if (!this.confChange.isMaxLengthWords) {
      if (this.getTextLength(tempObject) >= this.confChange.maxlength) {
        tempObject = tempObject.split('').slice(0, this.confChange.maxlength).join('');
      }
    } else {
      console.log(tempObject);
      if (this.getWordCount(tempObject) >= this.confChange.maxlength) {
        console.log(tempObject.toString().split(' ').slice(0, this.confChange.maxlength));
        console.log(tempObject.toString().split(' ').slice(0, this.confChange.maxlength).join(' '));
        console.log('*************');
        console.log(this.bphChange);

        tempObject = tempObject.toString().split(' ').slice(0, this.confChange.maxlength).join(' ');
        this.tempObjectForNotManpowerTable[key] = tempObject;
        console.log(this.tempObjectForNotManpowerTable);
      }
    }
    this.pendingChangesGuard.isPristine = false;
  }

  getYearErrorMessages(headerRowIndex, componentName) {
    if (this.tables[1].rows.length > 0) {
      for (let i = 0; i < this.bphChange.numberOfYears; i++) {
        if (this.tables[1].rows[headerRowIndex].expandRows[i][componentName]
          && this.tables[1].rows[headerRowIndex].expandRows[i][componentName].error
          && this.tables[1].rows[headerRowIndex].expandRows[i][componentName].error[this.selectedLanguage]) {
          return this.tables[1].rows[headerRowIndex].expandRows[i][componentName].error;
        }
      }
    }
  }

  initializeYearRows(table) {
    if (table && !table.yearRows) {
      table.yearRows = Array(this.bphChange.numberOfYears).fill(0);
    }
  }

  ngOnInit() {
    console.log('************FB-BUDGET T1***********');
    console.log(this.bphChange);
    console.log(this.confChange);
    this.refreshDataService.showSecondTable = true;

    if (!this.bphChange) {
      this.bphChange.numberOfBudgetTables = [];
    } else {
      this.tables = this.bphChange.numberOfBudgetTables;
      this.refreshDataService.bphChange = this.bphChange;
      this.bphChange.numberOfBudgetTables[0].subCategory = this.bphChange.subCategoryValue;
    }

    this.initializeNumberOfBudgetTablesInBphChange();


    this.initializeYearRows(this.bphChange);
    this.initializeYearRows(this.bphChange.numberOfBudgetTables[0]);
    this.initializeYearRows(this.bphChange.numberOfBudgetTables[1]);
    this.initializeYearRows(this.bphChange.numberOfBudgetTables[2]);


    this.setupBudgetTables();

    if (!this.globalPrj.upload_to_be_deleted) {
      this.globalPrj.upload_to_be_deleted = [];
    }

    if (this.showSummaryTable && this.bphChange.numberOfBudgetTables[1].rows) {
      this.groupedByTableOneRows = ECaseUtils.groupBy(this.bphChange.numberOfBudgetTables[1].rows, item => item.category.value);
    }
    if (this.showSummaryTable && this.bphChange.numberOfBudgetTables[2]?.rows) {
      this.groupedByTableTwoRows = ECaseUtils.groupBy(this.bphChange.numberOfBudgetTables[2].rows, item => item.category.value);
    }

    console.log(this.groupedByTableOneRows);

    this.tables.forEach((table) => {
      table.rows.forEach((row) => {
        row.descriptionError = {};
        row.descriptionError.error = {};
        row.subCategoryError = {};
        row.subCategoryError.error = {};
        row.categoryError = {};
        row.categoryError.error = {};

        row.expandRows.forEach((expandRow) => {
          if(!expandRow.fundsFromKfas || expandRow.fundsFromKfas === '') {expandRow.fundsFromKfas = 0;}
          if(!expandRow.fundsFromOtherInstitution || expandRow.fundsFromOtherInstitution === '') {expandRow.fundsFromOtherInstitution = 0;}
          if(!expandRow.subTotal || expandRow.subTotal === '') {expandRow.subTotal = 0;}
          expandRow.subTotalError = {};
          expandRow.subTotalError.error = {};
          expandRow.fundsFromKfasError = {};
          expandRow.fundsFromKfasError.error = {};
          expandRow.fundsFromOtherInstitutionError = {};
          expandRow.fundsFromOtherInstitutionError.error = {};

        });
      });
    });

    this.calculateYearTotals(this.bphChange.numberOfBudgetTables[0]);
    this.calculateYearTotals(this.bphChange.numberOfBudgetTables[1]);
    this.calculateYearTotals(this.bphChange.numberOfBudgetTables[2]);
    this.calculateTableTotals();
    console.log(this.tables);
    this.hasAnyNonManpowerRows = this.tables.some(
      t => !t.isManPowerTable && t.rows?.length > 0
    );
    this.firstNonManpowerIndex = this.tables.findIndex(
      t => !t.isManPowerTable
    );
    this.pendingChangesGuard.isPristine = false;
  }


  private setupBudgetTables(){
    if (this.confChange.isBudgetTypeInOpexSection !== undefined && this.confChange.isBudgetTypeInOpexSection === true) {
      this.bphChange.numberOfBudgetTables[0] =
        {
          'hasOptionSelected': true,
          'isManPowerTable': true,
          'rows': []
        };
      for (const lov in this.globalConf.lovs) {
        if (this.globalConf.lovs[lov].name === '10005') {
          // this.subCategoryList = this.globalConf.lovs[lov].list;
          this.subCategoryList = this.globalConf.lovs[lov].list.sort((a, b) => (a.label[this.translateService.getDefaultLang()] > b.label[this.translateService.getDefaultLang()]) ? 1 : ((b.label[this.translateService.getDefaultLang()] > a.label[this.translateService.getDefaultLang()]) ? -1 : 0));


        }
        if (this.globalConf.lovs[lov].name === '10006') {
          this.tempObjectForNotManpowerTable.category = this.globalConf.lovs[lov].list[0];
          this.searchResultForCategory = this.globalConf.lovs[lov].list;
        }

      }
      console.log('***********this.subCategoryList****************');
      console.log(this.subCategoryList);

    } else if (this.confChange.isBudgetTypeInCapexSection !== undefined && this.confChange.isBudgetTypeInCapexSection === true) {
      this.bphChange.numberOfBudgetTables[0] =
        {
          'hasOptionSelected': true,
          'isManPowerTable': true,
          'rows': []
        };

      for (const lov in this.globalConf.lovs) {
        if (this.globalConf.lovs[lov].name === '10007') {
          this.tempObjectForNotManpowerTable.subCategory = JSON.parse(JSON.stringify(this.globalConf.lovs[lov].list[0]));
          this.subCategoryList = this.globalConf.lovs[lov].list.sort((a, b) => (a.label[this.translateService.getDefaultLang()] > b.label[this.translateService.getDefaultLang()]) ? 1 : ((b.label[this.translateService.getDefaultLang()] > a.label[this.translateService.getDefaultLang()]) ? -1 : 0));
          console.log('222222222222222222222222');
          console.log(this.subCategoryList);

        }
        if (this.globalConf.lovs[lov].name === '10006') {
          this.tempObjectForNotManpowerTable.category = this.globalConf.lovs[lov].list[1];
          this.searchResultForCategory = this.globalConf.lovs[lov].list;
        }
      }
    } else {
      this.showSummaryTable = true;
      for (const lov in this.globalConf.lovs) {
        if (this.globalConf.lovs[lov].name === '10005') {
          this.subCategoryList = this.globalConf.lovs[lov].list.sort((a, b) => (a.label[this.translateService.getDefaultLang()] > b.label[this.translateService.getDefaultLang()]) ? 1 : ((b.label[this.translateService.getDefaultLang()] > a.label[this.translateService.getDefaultLang()]) ? -1 : 0));
          console.log('3333333333333333333333');
          console.log(this.subCategoryList);
        }
        if (this.globalConf.lovs[lov].name === '10006') {
          this.tempObjectForNotManpowerTable.category = this.globalConf.lovs[lov].list[2];
          this.searchResultForCategory = this.globalConf.lovs[lov].list;

        }
      }

      console.log(this.searchResultForCategory);
      /*      this.calculateYearTotals(this.bphChange.numberOfBudgetTables[0]);
            this.calculateYearTotals(this.bphChange.numberOfBudgetTables[1]);
            this.calculateTableTotals();
            this.emitSaveEvent.emit();*/

//      this.emitSaveEvent.emit();
    }
  }

  private initializeNumberOfBudgetTablesInBphChange() {
    const defaultTableSettings = (hasOptionSelected, isManPowerTable) => ({
      hasOptionSelected,
      isManPowerTable,
      rows: []
    });

    // Initialize numberOfBudgetTables with default settings
    this.bphChange.numberOfBudgetTables ??= [
      defaultTableSettings(true, true),
      {...defaultTableSettings(false, false)},
      {...defaultTableSettings(false, false)}
    ];

    // Ensure there are at least 3 tables in numberOfBudgetTables
    for (let i = 1; i <= 2; i++) {
      this.bphChange.numberOfBudgetTables[i] ??= {...defaultTableSettings(false, false)};
    }
  }

  calculateTableTotals() {
    this.bphChange.numberOfBudgetTables[1].rows.forEach((item) => {
      this.onKfasFundsInput(this.bphChange.numberOfBudgetTables[1], item);
      this.onSubTotalInput(this.bphChange.numberOfBudgetTables[1], item);
      this.onOtherInstitutionFundsInput(this.bphChange.numberOfBudgetTables[1], item);

    });

    this.bphChange.numberOfBudgetTables[2]?.rows.forEach((item) => {
      this.onKfasFundsInput(this.bphChange.numberOfBudgetTables[2], item);
      this.onSubTotalInput(this.bphChange.numberOfBudgetTables[2], item);
      this.onOtherInstitutionFundsInput(this.bphChange.numberOfBudgetTables[2], item);

    });

    this.bphChange.numberOfBudgetTables[0].rows.forEach((item) => {
      this.onKfasFundsInput(this.bphChange.numberOfBudgetTables[0], item);
      this.onSubTotalInput(this.bphChange.numberOfBudgetTables[0], item);
      this.onOtherInstitutionFundsInput(this.bphChange.numberOfBudgetTables[0], item);

    });
  }

  getTranslatedLabel(key: string) {

    return ECaseUtils.getTranslatedValueFromKey(this.translate, key, this.selectedLanguage);
  }


  ngOnDestroy() {
    this.pendingChangesGuard.isPristine = true;
    this.emitOutputEvent.emit(true);
    this.refreshDataService.toggleShowSaveNavBar(true);
  }

  onEditManpowerTableRow(manPowerTableRow, index, table) {
    this.oldBPHChange = cloneDeep(this.bphChange);
    this.showEditManpowerTable = true;
    this.indexOfEditedTable = index;
    this.manPowerEditRow = manPowerTableRow;
    this.manPowerEditRowIndex = index;
    this.selectedTableToEdit = table;
    this.emitOutputEvent.emit(false);
    this.refreshDataService.toggleShowSaveNavBar(false);

  }


  confirmEditingTheManpowerTableRow(row) {

    this.showEditManpowerTable = false;
    console.log(this.bphChange);
    // this.emitSaveEvent.emit();
    this.emitOutputEvent.emit(true);
    this.refreshDataService.toggleShowSaveNavBar(true);
    this.pendingChangesGuard.isPristine = true;

  }

  uploadDone1(event, row) {
    row.uploadFile = [];
    const documentPath = event.target.value;
    if (documentPath.includes('.pdf')) {
      console.log('GOOD');
      const formData = new FormData();
      formData.append(event.target.files[0].name, event.target.files[0]);
      formData.append('documentTypeId', this.confChange.staticDocumentType);
      formData.append('selectedSectionId', this.selectedSectionId);
      formData.append('formId', this.formId);
      formData.append('blockIndex', this.blockIndex.toString());
      console.log(formData);
      console.log(event);

      this.http.post('/api/fileUpload', formData).subscribe((_data: any) => {
        console.log(_data);
        if (_data.hasOwnProperty('status') && !_data.status) {
          alert(this.selectedLanguage === 'en' ? 'Upload failed' : 'Le téléchargement a échoué');
        } else {
          if (_data.docsIds.length === 1) {
            const upload_id = _data.docsIds[0];
            const upload_name = _data.docsNames[0];
            console.log(upload_name);
            const parsed_uploadName = upload_name.substring(upload_name.lastIndexOf('\\') + 1);
            console.log(parsed_uploadName);
            const tempObject = {
              'id': upload_id,
              'fileName': parsed_uploadName,
              'fileUploaded': true,
              'creation_date': new Date()
            };
            console.log(tempObject);
            row.uploadFile.push(tempObject);
            this.eCaseSnackBarService.showComponent('notice', this.selectedLanguage === 'en' ? '<b>File(s) uploaded.</b><br>Please save your data.' : '<b>Fichier(s) téléversé(s).</b><br>SVP sauvegarder vos données.');
            this.pendingChangesGuard.isPristine = false;
          }
          if (_data.docsIds.length > 0) {
            this.globalPrj.docsIds = [ ...this.globalPrj.docsIds , ..._data.docsIds];
          }
        }
      }, error => this.eCaseSnackBarService.show('failure', error.errorMessage));
    } else {
      const msg = ECaseUtils.getTranslatedValueFromKey(this.translateService, 'ecase.common.uploadRequiredExtensionsMessage', this.selectedLanguage) + '.pdf';
      alert(msg);
    }
    console.log(this.bphChange);

  }

  deleteFile(fileUploaded, row) {
    console.log(fileUploaded);
    row.uploadFile = [];
    this.globalPrj.upload_to_be_deleted.push(fileUploaded.id);
  }


  checkSubCategory(event, row) {
    console.log(event);
    const obj = {label: {}, value: ''};
    this.subCategoryList.forEach((item) => {
      if (item.value === event) {
        obj.label = item.label;
        obj.value = item.value;
      }
    });
    row.subCategory = obj;
    console.log(row);

  }


  openDialog(dataToDisplay) {
    if (typeof dataToDisplay === 'string') {
      const dummyString = dataToDisplay;
      dataToDisplay = {};
      this.translateService.langs.forEach((lang) => {
        dataToDisplay[lang] = dummyString;
      });
    }
    this.dialog.open(DialogComponent, {
      width: '600px',
      data:
        {
          dialog: dataToDisplay,
          selectedLanguage: this.selectedLanguage
        }
    });
  }


  showTableRow(row, index) {
    console.log(index);
    row.isShowTableRow = !row.isShowTableRow;
  }

  test() {
    console.log('WHEN');
  }

  onSubTotalInput(table, row, expandRow?, $event?) {
    console.log('FFFFFFFFFFFF');
    console.log(row);
    console.log(expandRow);

    if ($event && expandRow.subTotal !== null) {
      const t = $event.target;
      if (t.hasAttribute('maxlength')) {
        t.value = t.value.slice(0, t.getAttribute('maxlength'));
        expandRow.subTotal = +((expandRow.subTotal).toString().slice(0, t.getAttribute('maxlength')));
        console.log('SUBTOTAL', expandRow.subTotal);
      }
    }

    let total = 0;
    let totalOfAllRows = 0;
    let superTotalOfEverything = 0;
    if (row.expandRows) {
      for (const expandRow of row.expandRows) {
        // expandRow.fundsFromOtherInstitution = expandRow.subTotal;
        total = +(total + expandRow.subTotal);
      }
    }

    row.grandSubTotal = total;
    table.rows.forEach((item) => {
      if (item.grandSubTotal) {
        totalOfAllRows += (this.eCaseNumberFormatterPipe.reverseFormatToNumber(item.grandSubTotal.toString(), !!this.confChange.currency));
      }

    });

    table.grandSubTotal = totalOfAllRows;
    this.bphChange.numberOfBudgetTables.forEach((item) => {
      const grandSubTotal = item.grandSubTotal ? +(this.eCaseNumberFormatterPipe.reverseFormatToNumber(item.grandSubTotal.toString(), !!this.confChange.currency)) : 0;
      superTotalOfEverything += (grandSubTotal);
    });

    this.bphChange.grandSubTotal =superTotalOfEverything;
    console.log(this.bphChange);
    this.calculateYearTotals(table);
    if (expandRow) {
      expandRow.fundsFromOtherInstitution = expandRow.subTotal - expandRow.fundsFromKfas;
      this.onOtherInstitutionFundsInput(table, row);
    }
  }

  calculateYearTotals(table) {
    if (table) {
      const yearRows = [];
      const totalYearRows = [];
      for (let i = 0; i < this.bphChange.numberOfYears; i++) {
        let yearCount = 0;
        table.rows.forEach((item) => {
          if (item.expandRows[i]) {
            // yearCount += +(item.expandRows[i].subTotal) + +(item.expandRows[i].fundsFromOtherInstitution) + +(item.expandRows[i].fundsFromKfas)
            yearCount += +(item.expandRows[i].subTotal);
          }
        });
        yearRows.push(yearCount);
      }
      table.yearRows = yearRows;
      for (let i = 0; i < this.bphChange.numberOfYears; i++) {
        this.bphChange.numberOfBudgetTables[0].yearRows[i] = this.bphChange.numberOfBudgetTables[0].yearRows[i] ? this.bphChange.numberOfBudgetTables[0].yearRows[i].toString() : '0';
        this.bphChange.numberOfBudgetTables[1].yearRows[i] = this.bphChange.numberOfBudgetTables[1].yearRows[i] ? this.bphChange.numberOfBudgetTables[1].yearRows[i].toString() : '0';
        this.bphChange.numberOfBudgetTables[2].yearRows[i] = this.bphChange.numberOfBudgetTables[2].yearRows[i] ? this.bphChange.numberOfBudgetTables[2].yearRows[i].toString() : '0';
        const totalForTheYear = (this.eCaseNumberFormatterPipe.reverseFormatToNumber(this.bphChange.numberOfBudgetTables[0].yearRows[i].toString(), !!this.confChange.currency) + this.eCaseNumberFormatterPipe.reverseFormatToNumber(this.bphChange.numberOfBudgetTables[1].yearRows[i].toString(), !!this.confChange.currency) + this.eCaseNumberFormatterPipe.reverseFormatToNumber(this.bphChange.numberOfBudgetTables[2].yearRows[i].toString(), !!this.confChange.currency));
        totalYearRows.push(totalForTheYear);
      }
      this.bphChange.yearRows = totalYearRows;
    }
  }

  onKfasFundsInput(table, row, expandRow?, $event?) {
    let total = 0;
    let totalOfAllRows = 0;
    let superTotalOfEverything = 0;

    if ($event && expandRow.subTotal !== null) {
      const t = $event.target;
      if (t.hasAttribute('maxlength')) {
        t.value = t.value.slice(0, t.getAttribute('maxlength'));
        expandRow.fundsFromKfas = +((expandRow.fundsFromKfas ? expandRow.fundsFromKfas : 0).toString().slice(0, t.getAttribute('maxlength')));
        console.log('KFAS TOTAL: ', expandRow.fundsFromKfas);
      }
    }

    if (row.expandRows) {
      for (const expandRow of row.expandRows) {
        total = +(total + expandRow.fundsFromKfas);
      }
    }

    row.grandTotalForKfasFunds = total;

    table.rows.forEach((item) => {
      if (item.grandTotalForKfasFunds) {
        totalOfAllRows += (this.eCaseNumberFormatterPipe.reverseFormatToNumber(item.grandTotalForKfasFunds.toString(), !!this.confChange.currency));
      }
    });
    table.grandTotalForKfasFunds = totalOfAllRows;

    this.bphChange.numberOfBudgetTables.forEach((item) => {
      const kfsFunds = item.grandTotalForKfasFunds ? this.eCaseNumberFormatterPipe.reverseFormatToNumber(item.grandTotalForKfasFunds, !!this.confChange.currency) : 0;
      superTotalOfEverything += +(kfsFunds);
    });
    this.bphChange.grandTotalForKfasFunds = superTotalOfEverything;
    // this.calculateYearTotals(table);
    if (expandRow) {
      expandRow.fundsFromOtherInstitution = expandRow.subTotal - expandRow.fundsFromKfas;
      this.onOtherInstitutionFundsInput(table, row);

    }
  }

  onOtherInstitutionFundsInput(table, row) {
    let total = 0;
    let totalOfAllRows = 0;
    let superTotalOfEverything = 0;
    let val;
    if (row.expandRows) {
      for (const expandRow of row.expandRows) {
        total = +(total + expandRow.fundsFromOtherInstitution);
        console.log('gggggggggggggggg');
        console.log(expandRow.fundsFromOtherInstitution);
        // expandRow = expandRow.toString();
        //  if(expandRow.fundsFromOtherInstitution.length>9){
        //    expandRow.fundsFromOtherInstitution=expandRow.fundsFromOtherInstitution.slice(0,9)
        //  }
        //  val = expandRow.fundsFromOtherInstitution;
      }
    }
    //   this.changeValueEventvalue2(val);
    row.grandTotalForOtherFunds = total;
    table.rows.forEach((item) => {
      if (item.grandTotalForOtherFunds) {
        totalOfAllRows += +(this.eCaseNumberFormatterPipe.reverseFormatToNumber(item.grandTotalForOtherFunds, !!this.confChange.currency));
      }
    });
    table.grandTotalForOtherFunds = totalOfAllRows;
    this.bphChange.numberOfBudgetTables.forEach((item) => {
      const grandTotalForOtherFunds = item.grandTotalForOtherFunds ? this.eCaseNumberFormatterPipe.reverseFormatToNumber(item.grandTotalForOtherFunds, !!this.confChange.currency) : 0;
      superTotalOfEverything += +(grandTotalForOtherFunds);
    });
    this.bphChange.grandTotalForOtherFunds = superTotalOfEverything;
    // this.calculateYearTotals(table);
  }

  onDeleteTable(row, rowIndex) {
    console.log(row);
    if (this.confChange.isConfirmDelete) {
      this.confChange.confirmDelete(this.globalPrj, this.globalConf, rowIndex);
    }
    this.tables[1].rows.splice(rowIndex, 1);
    this.onSubTotalInput(this.bphChange.numberOfBudgetTables[1], {});
    this.onOtherInstitutionFundsInput(this.bphChange.numberOfBudgetTables[1], {});
    this.onKfasFundsInput(this.bphChange.numberOfBudgetTables[1], {});
    this.pendingChangesGuard.isPristine = false;
  }

  onEditTable(row, rowIndex) {
    this.oldBPHChange = cloneDeep(this.bphChange);
    this.showSecondTable = true;
    this.tempObjectForNotManpowerTable = row;
    this.indexOfEditedTable = rowIndex;
    this.emitOutputEvent.emit(false);
    this.refreshDataService.toggleShowSaveNavBar(false);
    if (this.confChange.isBudgetTypeInCapexSection !== undefined && this.confChange.isBudgetTypeInCapexSection === true) {
      for (const key in this.globalPrj.budget) {
        if (key !== this.confChange.name && this.globalPrj.budget[key] && this.globalPrj.budget[key].globalShowDetail !== undefined) {
          this.globalPrj.budget[key].globalShowDetail = false;
        }
      }
    }
    if (this.confChange.isBudgetTypeInOpexSection !== undefined && this.confChange.isBudgetTypeInOpexSection === true) {
      for (const key in this.globalPrj.project_budget_operating_opex) {
        if (key !== this.confChange.name && this.globalPrj.project_budget_operating_opex[key] && this.globalPrj.project_budget_operating_opex[key].globalShowDetail !== undefined) {
          this.globalPrj.project_budget_operating_opex[key].globalShowDetail = false;
        }
      }
    }
    this.pendingChangesGuard.isPristine = true;
  }

  onAddTable() {
    this.refreshDataService.showSecondTable = false;

    this.oldBPHChange = cloneDeep(this.bphChange);
    let tempObject: any = {};
    if (this.confChange.isBudgetTypeInCapexSection !== undefined && this.confChange.isBudgetTypeInCapexSection === true) {
      tempObject = {
        'category': this.tempObjectForNotManpowerTable.category,
        'subCategory': this.tempObjectForNotManpowerTable.subCategory,
        'uploadFile': [],
        'description': '',
        'selectedSubCategoryList': [],
        'isRowAdded': false,
        'expandRows': [],
        'isShowTableRow': false,
        'descriptionError': {},
        'subCategoryError': {},
        'categoryError': {},
      };
    } else {

      tempObject = {
        'category': this.tempObjectForNotManpowerTable.category,
        'subCategory': {label: {}, value: ''},
        'uploadFile': [],
        'description': '',
        'selectedSubCategoryList': [],
        'isRowAdded': false,
        'expandRows': [],
        'isShowTableRow': false,
        'descriptionError': {},
        'subCategoryError': {},
        'categoryError': {},
      };
    }

    tempObject.descriptionError.error = {};
    tempObject.subCategoryError.error = {};
    tempObject.categoryError.error = {};
    tempObject.uniqueRowIndex = this.bphChange.numberOfBudgetTables[1] && this.bphChange.numberOfBudgetTables[1].rows.length > 0 ? (Math.max.apply(Math, this.bphChange.numberOfBudgetTables[1].rows.map(function(o) {
      return o.uniqueRowIndex ? o.uniqueRowIndex : 0;
    })) + 1) : 1;

    if (this.bphChange.numberOfYears) {
      for (let i = 0; i < this.bphChange.numberOfYears; i++) {
        const yearLabelObject = cloneDeep(this.confChange.yearLabel);
        Object.keys(this.confChange.yearLabel).forEach((key) => {
          yearLabelObject[key] = this.confChange.yearLabel[key] + ' ' + (i + 1);
        });
        const expandRow: any = {
          'label': yearLabelObject,
          'subTotal': '',
          'fundsFromKfas': '',
          'fundsFromOtherInstitution': '',
        };
        expandRow.subTotalError = {};
        expandRow.subTotalError.error = {};
        expandRow.fundsFromKfasError = {};
        expandRow.fundsFromKfasError.error = {};
        expandRow.fundsFromOtherInstitutionError = {};
        expandRow.fundsFromOtherInstitutionError.error = {};
        tempObject.expandRows.push(expandRow);
      }
    }

    this.tempObjectForNotManpowerTable = tempObject;
    // this.emitOutputEvent.emit(false);
    // this.emitOutputEventForBudgetTableAddRow.emit(this.confChange);
    if (this.confChange.isBudgetTypeInCapexSection !== undefined && this.confChange.isBudgetTypeInCapexSection === true) {
      for (const key in this.globalPrj.budget) {
        if (key !== this.confChange.name && this.globalPrj.budget[key] && this.globalPrj.budget[key].globalShowDetail !== undefined) {
          this.globalPrj.budget[key].globalShowDetail = false;
        }
      }
    }
    if (this.confChange.isBudgetTypeInOpexSection !== undefined && this.confChange.isBudgetTypeInOpexSection === true) {
      for (const key in this.globalPrj.project_budget_operating_opex) {
        if (key !== this.confChange.name && this.globalPrj.project_budget_operating_opex[key] && this.globalPrj.project_budget_operating_opex[key].globalShowDetail !== undefined) {
          this.globalPrj.project_budget_operating_opex[key].globalShowDetail = false;
        }
      }
    }
    this.showSecondTable = true;
    this.indexOfEditedTable = undefined;
    this.emitOutputEvent.emit(false);
    this.refreshDataService.toggleShowSaveNavBar(false);
  }

  confirm() {
    this.showSecondTable = false;
    this.refreshDataService.showSecondTable = true;
    const tempObject = cloneDeep(this.tempObjectForNotManpowerTable);
    if (this.indexOfEditedTable !== undefined) {
      this.bphChange.numberOfBudgetTables[1].rows[this.indexOfEditedTable] = tempObject;
    } else {
      this.bphChange.numberOfBudgetTables[1].rows.push(tempObject);
    }
    if (this.confChange.isAddRowFunctionActive && this.indexOfEditedTable === undefined) {
      this.confChange.addRow(this.globalPrj, this.globalConf, this.tempObjectForNotManpowerTable);
    } else if (this.confChange.isEditRowFunctionActive && this.indexOfEditedTable !== undefined) {
      const oldData = this.oldBPHChange.numberOfBudgetTables[1].rows[this.indexOfEditedTable];
      this.confChange.editRow(this.globalPrj, this.globalConf, this.indexOfEditedTable, oldData);
    }

    this.onSubTotalInput(this.bphChange.numberOfBudgetTables[1], tempObject);
    this.onOtherInstitutionFundsInput(this.bphChange.numberOfBudgetTables[1], tempObject);
    this.onKfasFundsInput(this.bphChange.numberOfBudgetTables[1], tempObject);
    this.emitOutputEvent.emit(true);
    this.refreshDataService.toggleShowSaveNavBar(true);
    if (this.confChange.isBudgetTypeInCapexSection !== undefined && this.confChange.isBudgetTypeInCapexSection === true) {
      for (const key in this.globalPrj.budget) {
        if (key !== this.confChange.name && this.globalPrj.budget[key] && this.globalPrj.budget[key].globalShowDetail !== undefined) {
          this.globalPrj.budget[key].globalShowDetail = true;
        }
      }
    }
    if (this.confChange.isBudgetTypeInOpexSection !== undefined && this.confChange.isBudgetTypeInOpexSection === true) {
      for (const key in this.globalPrj.project_budget_operating_opex) {
        if (key !== this.confChange.name && this.globalPrj.project_budget_operating_opex[key] && this.globalPrj.project_budget_operating_opex[key].globalShowDetail !== undefined) {
          this.globalPrj.project_budget_operating_opex[key].globalShowDetail = true;
        }
      }
    }
    this.pendingChangesGuard.isPristine = true;
  }

  cancel() {
    this.refreshDataService.showSecondTable = true;

    if (this.confChange.isBudgetTypeInCapexSection !== undefined && this.confChange.isBudgetTypeInCapexSection === true) {
      for (const key in this.globalPrj.budget) {
        if (key !== this.confChange.name && this.globalPrj.budget[key] && this.globalPrj.budget[key].globalShowDetail !== undefined) {
          this.globalPrj.budget[key].globalShowDetail = true;
        }
      }
    }
    if (this.confChange.isBudgetTypeInOpexSection !== undefined && this.confChange.isBudgetTypeInOpexSection === true) {
      for (const key in this.globalPrj.project_budget_operating_opex) {
        if (key !== this.confChange.name && this.globalPrj.project_budget_operating_opex[key] && this.globalPrj.project_budget_operating_opex[key].globalShowDetail !== undefined) {
          this.globalPrj.project_budget_operating_opex[key].globalShowDetail = true;
        }
      }
    }

    this.bphChange = cloneDeep(this.oldBPHChange);
    (this.globalPrj[this.confChange.selectedSection.id])[this.confChange.name] = this.bphChange;
    this.tables = this.bphChange.numberOfBudgetTables;
    this.showSecondTable = false;
    this.showEditManpowerTable = false;
    this.emitOutputEvent.emit(true);
    this.refreshDataService.toggleShowSaveNavBar(true);
    this.pendingChangesGuard.isPristine = true;

  }

  replaceDescriptionLabelWithYears(value) {
    if (value) {
      let newValue = value[this.selectedLanguage];
      newValue = newValue.replace('$numberOfYears', this.bphChange.numberOfYears);
      return newValue;
    } else {
      return '';
    }
  }

  convertNumberToCurrencyFormat(value, currency) {
    return this.eCaseNumberFormatterPipe.transform(value, !!currency);
  }

}
